/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  class BeforeAfter {
      constructor(enteryObject) {
  
          const beforeAfterContainer = document.querySelector(enteryObject.id);
          const before = beforeAfterContainer.querySelector('.bal-before');
          const beforeText = beforeAfterContainer.querySelector('.bal-beforePosition');
          const afterText = beforeAfterContainer.querySelector('.bal-afterPosition');
          const handle = beforeAfterContainer.querySelector('.bal-handle');
          var widthChange = 0;
  
          beforeAfterContainer.querySelector('.bal-before-inset').setAttribute("style", "width: " + beforeAfterContainer.offsetWidth + "px;")
          window.onresize = function () {
              beforeAfterContainer.querySelector('.bal-before-inset').setAttribute("style", "width: " + beforeAfterContainer.offsetWidth + "px;")
          }
          before.setAttribute('style', "width: 50%;");
          handle.setAttribute('style', "left: 50%;");
  
          //touch screen event listener
          beforeAfterContainer.addEventListener("touchstart", (e) => {
  
              beforeAfterContainer.addEventListener("touchmove", (e2) => {
                  let containerWidth = beforeAfterContainer.offsetWidth;
                  let currentPoint = e2.changedTouches[0].clientX;
  
                  let startOfDiv = beforeAfterContainer.offsetLeft;
  
                  let modifiedCurrentPoint = currentPoint - startOfDiv;
  
                  if (modifiedCurrentPoint > 10 && modifiedCurrentPoint < beforeAfterContainer.offsetWidth - 10) {
                      let newWidth = modifiedCurrentPoint * 100 / containerWidth;
  
                      before.setAttribute('style', "width:" + newWidth + "%;");
                      afterText.setAttribute('style', "z-index: 1;");
                      handle.setAttribute('style', "left:" + newWidth + "%;");
                  }
              });
          });
  
          //mouse move event listener
          beforeAfterContainer.addEventListener('mousemove', (e) => {
              let containerWidth = beforeAfterContainer.offsetWidth;
              widthChange = e.offsetX;
              let newWidth = widthChange * 100 / containerWidth;
  
              if (e.offsetX > 10 && e.offsetX < beforeAfterContainer.offsetWidth - 10) {
                  before.setAttribute('style', "width:" + newWidth + "%;");
                  afterText.setAttribute('style', "z-index:" + "1;");
                  handle.setAttribute('style', "left:" + newWidth + "%;");
              }
          })
  
      }
  }

  var balItems = document.querySelectorAll('.bal-container');
  balItems.forEach(function(item){
    var id = item.getAttribute('id');
    new BeforeAfter({
      id: '#' + id
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

document.addEventListener("DOMContentLoaded", function(event) {
  var beforeAfterImagesSections = document.querySelectorAll('.hair-product-before-after-images');
  var beforeAfterImagesSectionsButtons = document.querySelectorAll('.hair-product-before-after-images .action-button');
  if (beforeAfterImagesSections.length && beforeAfterImagesSectionsButtons.length) {
    beforeAfterImagesSectionsButtons.forEach(function(item){
      item.addEventListener("mouseup", function(e) { 
        var parentElement = this.parentElement.parentElement;
        var imagesBlocks = parentElement.querySelectorAll('.image-container');
        parentElement.classList.remove('show-after');
        if (imagesBlocks.length) {
          imagesBlocks.forEach(function(el){
            el.classList.remove('show-after-img');
          });
        }
      });

      item.addEventListener("mousedown", function(e) { 
        var parentElement = this.parentElement.parentElement;
        var imagesBlocks = parentElement.querySelectorAll('.image-container');
        parentElement.classList.add('show-after');
        if (imagesBlocks.length) {
          imagesBlocks.forEach(function(el){
            el.classList.add('show-after-img');
          });
        }
      });

      item.addEventListener("touchend", function(e) { 
        var parentElement = this.parentElement.parentElement;
        var imagesBlocks = parentElement.querySelectorAll('.image-container');
        parentElement.classList.remove('show-after');
        if (imagesBlocks.length) {
          imagesBlocks.forEach(function(el){
            el.classList.remove('show-after-img');
          });
        }
      });

      item.addEventListener("touchstart", function(e) { 
        var parentElement = this.parentElement.parentElement;
        var imagesBlocks = parentElement.querySelectorAll('.image-container');
        parentElement.classList.add('show-after');
        if (imagesBlocks.length) {
          imagesBlocks.forEach(function(el){
            el.classList.add('show-after-img');
          });
        }
      });
    })
  }

  document.addEventListener('click', function(e){
  	let el = e.target;
    
    if(el.classList.contains('custom_video__share_icon') || el.closest('.custom_video__share_icon')) {
      if(!el.classList.contains('custom_video__share_icon')) {
      	el = el.closest('.custom_video__share_icon');
      }
      
      e.preventDefault();
    let url = window.location.origin + window.location.pathname  + '#video';

        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      
        navigator.share({
    title: '',
    text: '',
    url: url
  });
        } else {
        navigator.clipboard.writeText(url);   
      
      el.classList.add('copied');
      setTimeout(function () {
         el.classList.remove('copied');
      },2000);
        }
    }
  });

  

  
});
window.onload = function(e){ 
     if(window.location.href.indexOf('#video') >= 0) {
       window.history.pushState({}, document.title, window.location.pathname ); 
    }
};

$(document).ready(function () {
  var topPromoSection = $('.top-promo-section');
  var mainHeader = $('#shopify-section-header');
  var announcementBar = $('#shopify-section-announcement');
  var topPromoSectionDelay = topPromoSection.attr('data-delay') * 1000;
  var topPromoSectionHeight;
  var announcementBarHeight;
  var date = new Date();
  var announcementBarIsSticky = false;

  if ($('.announcement__wrapper').attr('data-sticky') == 'true') {
    announcementBar.css('position', 'sticky');
    announcementBar.css('top', '0');
    announcementBarIsSticky = true;
    mainHeader.css('top', announcementBar.outerHeight() + 'px');
    document.documentElement.style.setProperty('--mobile-menu-height', (announcementBar.outerHeight() + 50)  + "px");
    }

  if (topPromoSectionDelay == 0) {
    topPromoSectionDelay = 500;
  }

  if (date.getTime() >= +localStorage.getItem("showTopPromoSectionTime")) {
    localStorage.removeItem("showTopPromoSectionTime");
    localStorage.removeItem("hiddenTopPromoSection");
  }
 
  if (localStorage.getItem("hiddenTopPromoSection") != 'true') {
    setTimeout(function () {
      var copied_elem = topPromoSection.clone().css({visibility:"hidden", display:"block", position:"absolute"});
      $("body").append(copied_elem);
      topPromoSectionHeight = copied_elem.outerHeight();
      copied_elem.remove();
      console.log(topPromoSectionHeight)
      announcementBarHeight = announcementBar.outerHeight();
      announcementBar.css('top', topPromoSectionHeight + 'px');
      document.documentElement.style.setProperty('--mobile-menu-height', (announcementBar.outerHeight() + topPromoSectionHeight + 50)  + "px");
      if (announcementBarIsSticky) {        
        mainHeader.css('top', topPromoSectionHeight + announcementBarHeight + 'px');
      } else {
        mainHeader.css('top', topPromoSectionHeight + 'px');
      }
      topPromoSection.slideDown(300);
      topPromoSection.addClass('is-open');
    }, topPromoSectionDelay);
  }

  $(window).resize(function() {
    if (topPromoSection.hasClass('is-open')) {
      announcementBar.css('top', topPromoSection.outerHeight() + 'px');
      document.documentElement.style.setProperty('--mobile-menu-height', (announcementBar.outerHeight() + topPromoSection.outerHeight() + 50)  + "px");

      if (announcementBarIsSticky) {
        mainHeader.css('top', topPromoSection.outerHeight() + announcementBar.outerHeight() + 'px');
      } else {
        mainHeader.css('top', topPromoSection.outerHeight() + 'px');
      }
    }
  });

  $('.top-promo-section .top-promo-section-close').on('click', function() {
    $('.top-promo-section').slideUp(300);
    $('.top-promo-section').removeClass('is-open');
    document.documentElement.style.setProperty('--mobile-menu-height', (announcementBar.outerHeight() + 50)  + "px");
    announcementBar.css('top', '0');
    if (announcementBarIsSticky) {
      mainHeader.css('top', announcementBar.outerHeight() + 'px');
    } else {
      mainHeader.css('top', '0');
    }
    var dateToShow = date.getTime() + 1000 * 60 * 60 * 24;
    localStorage.setItem("hiddenTopPromoSection", "true");
    localStorage.setItem("showTopPromoSectionTime", dateToShow);
  });
});



document.addEventListener('click', function(e) {
  var el = e.target;
  if(el.closest('.custom-dropdown-wrapper')) {

    if(!el.classList.contains('main-field')) {
      el = el.closest('.main-field');
    }

    var customDropdownWrapper = el;

    if(customDropdownWrapper) {
      if(!customDropdownWrapper.classList.contains('custom-dropdown')) {
        customDropdownWrapper = customDropdownWrapper.closest('.custom-dropdown');
      }

      var customDropdown = customDropdownWrapper.querySelector('.main-field');





      var customDropdownList = el.nextElementSibling;      
      var bounding = customDropdown.getBoundingClientRect();
      var dropdownFromTop = bounding.top;

      if (customDropdownList != null) {
        if (customDropdownList.classList.contains('open')) {
          customDropdownList.classList.remove("open");
          customDropdown.classList.remove("top-list");
          customDropdown.classList.remove("bottom-list");
        } else {
          customDropdownList.classList.add("open");
          customDropdown.classList.add("bottom-list");
        }
      }
    }
  } else {
    if (document.querySelector('.custom-dropdown-list') != null && document.querySelector('.main-field') != null) {
      document.querySelector('.custom-dropdown-list').classList.remove("open");
      document.querySelector('.main-field').classList.remove("top-list");
      document.querySelector('.main-field').classList.remove("bottom-list");
    }
  }

});

document.addEventListener('click', function(e) {

  var el = e.target;
  if(el.classList.contains('custom-dropdown-list-item') || el.closest('.custom-dropdown-list-item')) {
    if(!el.classList.contains('custom-dropdown-list-item')) {
      el = el.closest('.custom-dropdown-list-item');
    }

    var elementParent = el.parentElement;
    var dropdownWrapper = elementParent.previousElementSibling;
    var elementContent = el.innerHTML;


    //var optionsSelect = document.querySelector('.single-option-selector');

    var optionValue = el.querySelector("span").innerHTML;
    if(elementParent.querySelector('.custom-dropdown-list-item.selected')) {
      elementParent.querySelector('.custom-dropdown-list-item.selected').classList.remove("selected");
    }
    el.classList.add("selected");
    dropdownWrapper.classList.remove("top-list");
    dropdownWrapper.classList.remove("bottom-list");
    elementParent.classList.remove("open");
    dropdownWrapper.innerHTML = elementContent;


    var color_value = el.getAttribute('data-color-value');
    console.log(el);
    console.log(1);
    var ColorSwatch__Radio_arr = el.closest('.selector-wrapper').querySelectorAll('[data-single-option-selector]');
    for(var i=0;i < ColorSwatch__Radio_arr.length;i++) {
      var ColorSwatch__Radio = ColorSwatch__Radio_arr[i];
      var val = ColorSwatch__Radio.getAttribute('data-value');
      if(val == color_value) {
        ColorSwatch__Radio.click();
        break;
      }
    }
  }

});

$(document).ready(function() {
  if ($(window).width() < 750) {
   $('.product-form-fields-wrapper').addClass('is-fixed');
  }
  // $(window).scroll(function(event) {
  //   if ($(window).width() < 750) {
  //     if ($('.product-form-fields-wrapper-container').offset().top + $('.product__submit__buttons .product__submit__add[type="submit"]').outerHeight() < $(window).scrollTop() + $('#shopify-section-top-promo').outerHeight() + $('#shopify-section-announcement').outerHeight() + $('#shopify-section-header').outerHeight()) {
  //       $('.product-form-fields-wrapper').addClass('is-fixed');
  //     } else {
  //       $('.product-form-fields-wrapper').removeClass('is-fixed');
  //     }
  //   }
  // });

  $('.product-item .product-information').matchHeight();
});


    if ($(window).width() < 750) {
    // Function to check the scroll position and add/remove class
    function checkScroll() {
        var scrollPosition = $(window).scrollTop();
        var elementOffset = $('.custom-location-sho-pay').offset().top;
        var distance = elementOffset - 50; // 50px below the element

        if (scrollPosition > distance) {
            $('.product-form-fields-wrapper').addClass('is-fixed');
        } else {
            $('.product-form-fields-wrapper').removeClass('is-fixed');
        }
    }

    // Attach the function to the window scroll event
    $(window).scroll(checkScroll);
    };

  /*
   * Free-shipping banner state fix.
   *
   * THEME BUG (theme.js, CartDrawer.freeShippingMessageHandle):
   *   message.classList.toggle(cartMessageClass, total >= limit || total === 0)
   * adds OR removes one of {is-hidden, is-success} per call, never clearing
   * the opposite class. Three observed failure modes:
   *   1. Empty -> populated: server-rendered `is-hidden` persists.
   *   2. Empty -> cheap product (toggle('is-success', false) is a no-op
   *      when is-success isn't already present, so no DOM mutation fires
   *      and the stale is-hidden never gets cleared).
   *   3. Above-threshold -> empty -> below-threshold: stale is-hidden left
   *      behind from the empty transition hides the "$X more" countdown.
   *
   * FIX:
   *   - Hook /cart/{add,change,update,clear} writes (theme uses fetch; we
   *     also patch XHR for any apps that might cart-write that way).
   *   - Refetch /cart.js for the canonical total (cheap; ~1KB).
   *   - Apply the correct class explicitly:
   *       total <= 0          -> is-hidden
   *       0 < total < limit   -> neither class (default "$X away" shows)
   *       total >= limit      -> is-success (or is-hidden if no qualified copy)
   *
   * Idempotent: only mutates the classList when current state differs from
   * desired. Idempotency matters for safety against the rare race condition
   * where two reconciles fire concurrently — they converge instead of fighting.
   */
  function applyCartMessageState(messages, total) {
    if (typeof total !== 'number' || isNaN(total)) return;
    messages.forEach(function (message) {
      var limit = (parseFloat(message.getAttribute('data-limit')) || 0) * 100;
      var hasQualified = message.getAttribute('data-cart-message') === 'true';
      var hasHidden = message.classList.contains('is-hidden');
      var hasSuccess = message.classList.contains('is-success');

      var desired;
      if (total <= 0) {
        desired = 'is-hidden';
      } else if (total >= limit) {
        desired = hasQualified ? 'is-success' : 'is-hidden';
      } else {
        desired = '';
      }

      if (desired === 'is-hidden') {
        if (!hasHidden) message.classList.add('is-hidden');
        if (hasSuccess) message.classList.remove('is-success');
      } else if (desired === 'is-success') {
        if (!hasSuccess) message.classList.add('is-success');
        if (hasHidden) message.classList.remove('is-hidden');
      } else {
        if (hasHidden) message.classList.remove('is-hidden');
        if (hasSuccess) message.classList.remove('is-success');
      }

      // Progress bar fill — theme.js's updateProgress uses
      // document.querySelector('.progress-bar-val') (single match), so
      // when more than one cart-message exists in the DOM (cart drawer
      // + cart page + announcement), only the first bar gets its width
      // updated and the rest stay frozen at the inline width Liquid
      // rendered at page load. Update each scoped bar so all stay in sync.
      var bar = message.querySelector('.progress-bar-val');
      if (bar) {
        var percent = limit > 0 ? Math.min(100, (total / limit) * 100) : 0;
        bar.style.width = percent + '%';
      }
    });
  }

  var reconcileTimer = null;
  function scheduleCartMessageReconcile() {
    if (reconcileTimer) clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(function () {
      reconcileTimer = null;
      var messages = document.querySelectorAll('[data-cart-message]');
      if (!messages.length) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (cart && typeof cart.total_price === 'number') {
            applyCartMessageState(messages, cart.total_price);
          }
        })
        .catch(function () { /* leave existing state alone on failure */ });
    }, 100);
  }

  function isCartWriteUrl(url) {
    if (typeof url !== 'string') return false;
    var pathname = url.split('?')[0].split('#')[0];
    return /\/cart\/(add|change|update|clear)(\.js)?$/.test(pathname);
  }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var promise = origFetch.apply(this, arguments);
      if (isCartWriteUrl(url)) {
        promise.then(scheduleCartMessageReconcile, function () {});
      }
      return promise;
    };
  }

  var origXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && isCartWriteUrl(url)) {
      this.addEventListener('load', scheduleCartMessageReconcile);
    }
    return origXHROpen.apply(this, arguments);
  };

  // Lip oil balm — variant carousel swap via URL navigation.
  // The bundled theme.js's updateProductImage looks for the new variant's
  // featured_media slide inside the live slider, but the live slider only
  // contains the *current* variant's media (the .Product__Slideshow_all_images_container
  // pattern in theme.dev.js was never bundled into prod). On swatch click
  // its querySelector returns null and .closest() throws. We sidestep by
  // navigating to ?variant=<id> so the server re-renders the gallery —
  // sections/product.liquid:125 already picks the correct featured_media
  // for the selected variant.
  (function () {
    if (!window.location.pathname.startsWith('/products/lip-oil-balm')) return;

    function loadProduct() {
      var inline = document.querySelector('[data-product-json]');
      if (inline && inline.textContent) {
        try { return Promise.resolve(JSON.parse(inline.textContent)); } catch (e) {}
      }
      return fetch('/products/lip-oil-balm.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }

    loadProduct().then(function (product) {
      if (!product || !Array.isArray(product.variants)) return;

      var colorToVariantId = Object.create(null);
      product.variants.forEach(function (v) {
        var color = String(v.option1 || '').trim().toLowerCase();
        if (color) colorToVariantId[color] = v.id;
      });

      // Capture phase + isTrusted check skips the document.ready auto-click
      // hacks at layout/theme.liquid:347 and :430 (programmatic .click()).
      document.addEventListener('change', function (ev) {
        if (!ev.isTrusted) return;
        var input = ev.target;
        if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
        if (!input.closest('.swatch__button')) return;

        var color = String(input.value || '').trim().toLowerCase();
        var variantId = colorToVariantId[color];
        if (!variantId) return;

        var current = new URLSearchParams(window.location.search).get('variant');
        if (current && current === String(variantId)) return;

        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(variantId));
        ['_pos', '_sid', '_ss'].forEach(function (p) { url.searchParams.delete(p); });
        window.location.assign(url.toString());
      }, true);
    });
  })();
